var exports = {
  "kL": "x1cb7f6e3--fc58ea--container",
  "wx": "x1cb7f6e3--fc58ea--header",
  "aW": "x1cb7f6e3--fc58ea--header-text",
  "VE": "x1cb7f6e3--fc58ea--header-logos",
  "Bm": "x1cb7f6e3--fc58ea--offers-list",
  "Jb": "x1cb7f6e3--fc58ea--offers-list--single",
};

module.exports = exports;
